export default {
      id: "chevrons-actualites-usage",
      viewBox: "0 0 185 365",
      url: "../dist/images/" + "sprite.svg#chevrons-actualites-usage",
      toString: function () {
        return this.url;
      }
    }